
function elegantFileInputs(selector){
    var selector = selector || '.field--fileinput';
    var inputs = document.querySelectorAll(selector);
    Array.prototype.forEach.call( inputs, function( input )
    {
        var label = input.nextElementSibling,
            labelVal = label.innerHTML;

        input.addEventListener( 'change', function(e) {
            //console.log(e);
            var fileName = '';
            if( this.files && this.files.length > 1 ) {
                fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
            } else {
                fileName = e.target.value.split( '\\' ).pop();
            }

            if( fileName ) {
                label.querySelector( 'span' ).innerHTML = fileName;
            } else {
                label.innerHTML = labelVal;
            }
        });
    });
}

function fieldsetRowDuplicate(selector,before) {
    var before = before || false;
    var $clone = $(selector).clone(true);
    $clone.find(':input:not(.clone-value)').each(function() {
        $(this).val('').removeAttr('checked').removeClass("input--error").removeAttr("disabled");
    });

    $clone.find('.alert--invalid,.alert--error').remove();
    $clone.find('.fieldset-row-messages').empty();

    $clone.addClass("animated--quickly puffIn");
    $clone.removeClass("block--hidden");

    if($clone.find('.fieldset-delete').length == 0){
        var $button = $('<button type="button" class="button--skinny button--flat fieldset-delete" title="Remove Item"><i class="icon-close"><span class="screenreader">Remove</span></i></button>');
        $button.click(function(){
            var $row = $(this).closest('.fieldset-row');
            $row.trigger("fieldsetrow:beforedelete");
            fieldsetRowRemove(this);
            $row.trigger("fieldsetrow:deleted");
        });
        $clone.append($button);
    }
    if(before){
        $(selector).before($clone);
    } else {
        $(selector).after($clone);
    }
    $clone.trigger("fieldsetrow:added");

}

function fieldsetRowRemove($button) {
    $($button).closest(".fieldset-row").remove();
}
